// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"RJ-z","carouselContainer":"SJ-z"};